(() => {
 const preference = matchMedia('(prefers-reduced-motion: reduce)');
 let observer, frame = 0;
 let media = [];
 const update = () => {
  frame = 0;
  if (preference.matches) return;
  media.forEach(el => {
   const box = el.closest("section").getBoundingClientRect();
   if (box.bottom < 0 || box.top > innerHeight * .88) return;
   const range = innerWidth < 750 ? 36 : 72;
   const progress = Math.max(-1, Math.min(1, (innerHeight / 2 - box.top - box.height / 2) / (innerHeight / 2 + box.height / 2)));
   el.style.setProperty('--ct-y', `${(progress * range).toFixed(2)}px`);
   el.style.setProperty('--ct-scale', (1 + (progress + 1) * .025).toFixed(3));
  });
 };
 const schedule = () => { if (!preference.matches && !frame) frame = requestAnimationFrame(update); };
 const init = () => {
  if (observer) observer.disconnect();
  media = [...document.querySelectorAll('[data-ct-parallax]')];
  document.querySelectorAll('.ct-pending').forEach(el => el.classList.remove('ct-pending'));
  media.forEach(el => { el.style.removeProperty('--ct-y'); el.style.removeProperty('--ct-scale'); });
  if (preference.matches) return;
  update();
  if (!('IntersectionObserver' in window)) return;
  observer = new IntersectionObserver(entries => entries.forEach(entry => {
   if (entry.target.classList.contains('ct-hero')) entry.target.classList.toggle('ct-inview', entry.isIntersecting);
   else if (entry.isIntersecting) {
    entry.target.classList.remove('ct-pending');
    entry.target.classList.add('ct-inview');
    observer.unobserve(entry.target);
   }
  }), {threshold: .12});
  document.querySelectorAll('.ct-reveal').forEach(el => {
   if (el.getBoundingClientRect().top > innerHeight * .88) el.classList.add('ct-pending');
   observer.observe(el);
  });
  document.querySelectorAll('.ct-hero').forEach(el => observer.observe(el));
  schedule();
 };
 addEventListener('scroll', schedule, {passive: true});
 addEventListener('resize', schedule, {passive: true});
 if (preference.addEventListener) preference.addEventListener('change', init);
 else preference.addListener(init);
 document.addEventListener('shopify:section:load', init);
 document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));
 document.addEventListener('shopify:section:select', event => event.target.querySelectorAll('.ct-pending').forEach(el => el.classList.remove('ct-pending')));
 document.addEventListener('change', event => {
  if (event.target.matches('[data-variant-picker]')) location.assign(event.target.value);
 });
 init();
})();
